export default "__VITE_ASSET__02b25690__"